import { Text, TextButton } from '@thefarmersfront/kitchen';

import { Caution } from '~/components/common';

import { EXTERNAL_URLS } from '~/constants';

/**
 * [입고관리 > 입고요청관리] 입고요청 등록/상세 모달 > 유의사항 영역
 */
const ReceiveRequestCaution = () => {
  const handleClickGuideLink = () => {
    window.open(EXTERNAL_URLS.RECEIVE_GUIDE_LINK, '_blank', 'noopener,noreferrer');
  };

  return (
    <Caution
      title="유의사항"
      showBullet
      contents={[
        {
          children:
            'Kurly Logistics Services에 등록된 상품만 입고 가능하며, 입고할 센터와 상품의 정보를 정확히 입력해주세요.',
        },
        {
          children: '입고예정일 D-1(16:00시 이후)에 입고 요청하려는 경우, 컬리에 사전 문의 후 진행해주세요.',
        },
        {
          children: '상품이 입고되어야 할 입고 센터의 상세 주소에 따라 입고 요청이 2개 이상으로 나뉠 수 있습니다.',
        },
        {
          children: (
            <>
              <Text size="medium" color="secondary">
                자세한 사항은 컬리 입고 가이드를 준수해주세요.
              </Text>
              <TextButton size="tiny" weight="semi-bold" color="secondary" onClick={handleClickGuideLink}>
                입고가이드 바로가기
              </TextButton>
            </>
          ),
        },
      ]}
    />
  );
};

export default ReceiveRequestCaution;
